module.exports = __webpack_public_path__ + "img/despensa.1cb05620.png";